import { connectHook } from '../../connect-hook.js';
import { Autocomplete, type AutocompleteProps } from './autocomplete.js';
import { type AutocompleteHookProps, useAutocomplete } from './autocomplete-hook.js';

export default connectHook<AutocompleteHookProps, AutocompleteProps>(Autocomplete, useAutocomplete);
